import React from 'react';
import PropTypes from 'prop-types';

const IconTrial = ({
  className = '',
  color = '#737373',
  width = '20px',
  height = '20px',
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.6113 0.25C2.09308 0.25 0.861298 1.48179 0.861298 3V21.6C0.861298 23.1182 2.09308 24.35 3.6113 24.35H20.6923C22.2112 24.35 23.4423 23.1185 23.4423 21.6V7.416H23.445V5.916H23.4423V3C23.4423 1.4815 22.2112 0.25 20.6923 0.25H3.6113ZM21.9423 5.916V3C21.9423 2.30981 21.3827 1.75 20.6923 1.75H17.372V4.0874H15.872V1.75H7.8203V4.0874H6.3203V1.75H3.6113C2.92151 1.75 2.3613 2.31021 2.3613 3V5.916H21.9423ZM2.3613 7.416V21.6C2.3613 22.2898 2.92151 22.85 3.6113 22.85H20.6923C21.3827 22.85 21.9423 22.2902 21.9423 21.6V7.416H2.3613ZM6.6048 13.9176C7.2168 13.9176 7.7138 13.4206 7.7138 12.8086C7.7138 12.1956 7.2168 11.6996 6.6048 11.6996C5.9908 11.6996 5.4948 12.1956 5.4948 12.8086C5.4948 13.4206 5.9908 13.9176 6.6048 13.9176ZM13.2617 12.8086C13.2617 13.4206 12.7647 13.9176 12.1527 13.9176C11.5387 13.9176 11.0427 13.4206 11.0427 12.8086C11.0427 12.1956 11.5387 11.6996 12.1527 11.6996C12.7647 11.6996 13.2617 12.1956 13.2617 12.8086ZM17.7005 13.9176C18.3125 13.9176 18.8095 13.4206 18.8095 12.8086C18.8095 12.1956 18.3125 11.6996 17.7005 11.6996C17.0865 11.6996 16.5895 12.1956 16.5895 12.8086C16.5895 13.4206 17.0865 13.9176 17.7005 13.9176ZM7.7138 18.4971C7.7138 19.1101 7.2168 19.6061 6.6048 19.6061C5.9908 19.6061 5.4948 19.1101 5.4948 18.4971C5.4948 17.8851 5.9908 17.3881 6.6048 17.3881C7.2168 17.3881 7.7138 17.8851 7.7138 18.4971ZM12.1527 19.6061C12.7647 19.6061 13.2617 19.1101 13.2617 18.4971C13.2617 17.8851 12.7647 17.3881 12.1527 17.3881C11.5387 17.3881 11.0427 17.8851 11.0427 18.4971C11.0427 19.1101 11.5387 19.6061 12.1527 19.6061ZM18.8095 18.4971C18.8095 19.1101 18.3125 19.6061 17.7005 19.6061C17.0865 19.6061 16.5895 19.1101 16.5895 18.4971C16.5895 17.8851 17.0865 17.3881 17.7005 17.3881C18.3125 17.3881 18.8095 17.8851 18.8095 18.4971Z"
      fill={color}
    />
  </svg>
);

IconTrial.propTypes = {
  color: PropTypes.string,
  className: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
};

export default IconTrial;
